export default __webpack_public_path__ + "static/media/side.0b9e45a8.png";